<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    max-width="1000"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="$permission('53')"
        v-bind="attrs"
        v-on="on"
        small
        @click="openDialog()"
        color="primary"
        class="mr-2"
        :class="$vuetify.breakpoint.smAndDown ? 'mb-2' : ''"
      >
        <v-icon left>mdi-plus-box</v-icon>
        {{ $t("createNewPromotion") }}
      </v-btn>
    </template>
    <v-card>
      <v-form class="top" ref="form" v-model="valid">
        <v-toolbar>
          <v-toolbar-title>{{ $t("registerNewPromotion") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <div :class="$vuetify.breakpoint.smAndDown ? '' : 'px-6'">
          <v-card-text>
            <v-subheader class="overline">
              {{ $t("typeAndCodeOfPromotion") }}
            </v-subheader>
            <div class="pa-4 px-6">
              <v-select
                v-model="typePromotion"
                class="mb-6"
                :rules="[rules.required]"
                :items="items"
                item-text="text"
                item-value="status"
                :label="$t('typeOfPromotionSelect')"
                hide-details="auto"
                dense
                outlined
                return-object
              ></v-select>
              <v-text-field
                v-if="isPromotionToken"
                v-model="quantityTokens"
                class="mb-6"
                :label="$t('quantityOfTokensAsterisk')"
                :rules="[
                  rules.noSpacesAreAllowed,
                  rules.required,
                  rules.negativeNo,
                  rules.maxQuantityTokens,
                ]"
                hide-details="auto"
                dense
                type="text"
                :counter="4"
                maxlength="4"
                onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                outlined
              >
                <template v-slot:append-outer>
                  <div class="tooltip d-flex justify-center">
                    <v-icon class="tooltipIcon">mdi-information-outline</v-icon>
                    <span class="tooltipText body-2">{{ $t("tokenTip") }}</span>
                  </div>
                </template>
              </v-text-field>
              <v-text-field
                v-if="
                  isPromotionTypeDeposit || isPromotionTypeRegisterOrAffiliate
                "
                v-model="promotionCode"
                class="mb-6"
                :label="$t('promotionCode')"
                :rules="[
                  rules.noSpacesAreAllowed,
                  rules.required,
                  rules.max20,
                  rules.noSpecialCharactersAllowed,
                ]"
                hide-details="auto"
                dense
                :counter="20"
                maxlength="20"
                outlined
                :disabled="imageConfirmed"
              >
                <template v-slot:append-outer>
                  <div class="tooltip">
                    <v-icon class="tooltipIcon">mdi-information-outline</v-icon>
                    <span class="tooltipText body-2">{{
                      $t("promotionCodeTip")
                    }}</span>
                  </div>
                </template>
              </v-text-field>
            </div>

            <div class="pa-0 ma-0" v-if="typePromotion.status == 'afiliado'">
              <v-subheader class="overline pt-4">
                {{ $t("findAnAffiliate") }}
              </v-subheader>
              <!-- Autocomplete Agente -->
              <div class="mb-4 pa-4 px-6 ">
                <v-autocomplete
                  v-model="selectAffiliate"
                  :label="$t('autoCompleteAffiliatePlaceHolder')"
                  :no-data-text="$t('autoCompleteNoData')"
                  :items="affiliates"
                  :loading="isLoading"
                  :rules="[rules.required]"
                  :search-input.sync="search"
                  item-text="ui"
                  item-value="id"
                  :hint="$t('searchAffiliateSpan')"
                  persistent-hint
                  prepend-icon="mdi-magnify"
                  dense
                  outlined
                  clearable
                  hide-details="auto"
                  return-object
                >
                </v-autocomplete>
              </div>
            </div>

            <div class="pa-0 ma-0">
              <v-subheader class="overline pt-4">
                {{ `${$t("title")} ${$t("and")} ${$t("description")}` }}
              </v-subheader>
              <div class="mb-4 pa-4 px-6">
                <!-- Bonus - Dependendo do tipo pode ser aplicado como percentual ou valor absoluto. -->
                <v-text-field
                  v-model="promotion_title"
                  :rules="[rules.required]"
                  :label="$t('promotionTitle')"
                  hide-details="auto"
                  dense
                  outlined
                  :counter="40"
                  maxlength="40"
                ></v-text-field>
                <!-- Bonus Máximo (no caso de ser percentual) -->
                <v-text-field
                  class="pt-2"
                  v-model="promotion_description"
                  :rules="[rules.required]"
                  :label="$t('promotionDescription')"
                  hide-details="auto"
                  dense
                  outlined
                  :counter="50"
                  maxlength="50"
                ></v-text-field>
              </div>
            </div>

            <!-- row Date Start -->
            <v-subheader class="overline pt-4">
              {{ $t("validity") }}
            </v-subheader>
            <div class="pa-4 px-6">
              <v-row>
                <v-col>
                  <v-menu
                    v-model="menuStart"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    min-width="200"
                    class=""
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="computedDateFormattedStart"
                        outlined
                        :label="$t('dateStart')"
                        prepend-icon="mdi-calendar"
                        readonly
                        hint="DD/MM/YYYY"
                        hide-details="auto"
                        class=""
                        v-on="on"
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateStart"
                      @input="menuStart = false"
                      :min="dateGetTimezoneOffset"
                      no-title
                      scrollable
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="timeStart"
                    :rules="[rules.required]"
                    :label="$t('timeStart')"
                    prepend-icon="mdi-clock-time-twelve"
                    placeholder="hh:mm:ss"
                    dense
                    outlined
                    class=""
                    v-mask="'##:##:##'"
                    hide-details="auto"
                    :error="!hideDetailsStart"
                    :error-messages="errorTimeStart"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- row Date Final -->
              <v-row>
                <v-col>
                  <v-menu
                    v-model="menuFinal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="200"
                    class=""
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="computedDateFormattedFinal"
                        outlined
                        :label="$t('dateFinal')"
                        prepend-icon="mdi-calendar"
                        readonly
                        hint="DD/MM/YYYY"
                        hide-details="auto"
                        class=""
                        v-on="on"
                        dense
                        :rules="[rules.required]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateFinal"
                      @input="menuFinal = false"
                      :min="dateGetTimezoneOffset"
                      no-title
                      scrollable
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="timeFinal"
                    :rules="[rules.required]"
                    :label="$t('endTime')"
                    placeholder="hh:mm:ss"
                    prepend-icon="mdi-clock-time-eleven"
                    class=""
                    v-mask="'##:##:##'"
                    hide-details="auto"
                    dense
                    outlined
                    :error="!hideDetailsFinal"
                    :error-messages="errorTimeFinal"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
            <div>
              <v-subheader class="overline pt-4">
                {{ $t("rewardRules") }}
              </v-subheader>
              <div class="pa-4 px-6">
                <v-row>
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'">
                    <!-- Bonus - Dependendo do tipo pode ser aplicado como percentual ou valor absoluto. -->
                    <v-text-field
                      class="custom-prepend-inner-icon"
                      v-model="bonus_value"
                      :rules="[rules.required, rules.negativeNo]"
                      :label="
                        isPromotionTypeDeposit
                          ? $t('percentageOfBonus')
                          : $t('promotionLabelBonus')
                      "
                      prepend-icon="mdi-seal-variant"
                      :prefix="
                        isPromotionTypeDeposit ? '%' : $t('labelCurrency')
                      "
                      hide-details="auto"
                      dense
                      outlined
                      type="number"
                    >
                      <template v-slot:append-outer>
                        <div class="tooltip">
                          <v-icon class="tooltipIcon">
                            mdi-information-outline
                          </v-icon>
                          <span class="tooltipText body-2">
                            <span v-if="isPromotionTypeDeposit">
                              {{ $t("promotionTypeDepositTip") }}
                            </span>
                            <span v-else>
                              {{ $t("prmotionTypeRegisterOrAfiliateTip") }}
                            </span>
                          </span>
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col
                    v-if="isPromotionTypeDeposit"
                    :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'"
                  >
                    <!-- Bonus Máximo (no caso de ser percentual) -->
                    <v-text-field
                      v-model="bonus_max_value"
                      :rules="[rules.negativeNo]"
                      :label="$t('LabelMaximumBonusAmount')"
                      :prefix="$t('labelCurrency')"
                      hide-details="auto"
                      prepend-icon="mdi-license"
                      dense
                      outlined
                      type="number"
                    >
                      <template v-slot:append-outer>
                        <div class="tooltip">
                          <v-icon class="tooltipIcon">
                            mdi-information-outline
                          </v-icon>
                          <span class="tooltipText body-2">
                            {{ $t("bonusMaxValueTip") }}
                          </span>
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'">
                    <div class="d-flex align-center">
                      <div style="width: 100%">
                        <v-text-field
                          v-model="transfer_max_value"
                          :rules="[rules.negativeNo]"
                          :label="$t('maxTransference')"
                          :prefix="$t('labelCurrency')"
                          prepend-icon="mdi-bank-transfer"
                          hide-details="auto"
                          dense
                          outlined
                          type="number"
                        >
                          <template v-slot:append-outer>
                            <div class="tooltip">
                              <v-icon class="tooltipIcon">
                                mdi-information-outline
                              </v-icon>
                              <span class="tooltipText body-2">
                                {{ $t("maxTransferTooltip") }}
                              </span>
                            </div>
                          </template>
                        </v-text-field>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
            <!-- TEXT INPUTS -->
            <div>
              <div v-if="isPromotionTypeDeposit">
                <v-subheader class="overline pt-4">
                  {{ $t("adhesionRules") }}
                </v-subheader>
                <div class="pa-4 px-6">
                  <v-row>
                    <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'">
                      <v-text-field
                        v-model="deposito_min_value"
                        :rules="[rules.negativeNo]"
                        :label="$t('minimumDeposit')"
                        prepend-icon="mdi-cash-fast"
                        hide-details="auto"
                        dense
                        outlined
                        type="number"
                      >
                        <template v-slot:append-outer>
                          <div class="tooltip">
                            <v-icon class="tooltipIcon"
                              >mdi-information-outline</v-icon
                            >
                            <span class="tooltipText body-2">{{
                              $t("depositMinValueTip")
                            }}</span>
                          </div>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <v-subheader class="overline pt-4">
                {{ $t("rolloverRules") }}
              </v-subheader>
              <div class="pa-4 px-6">
                <v-row class="mb-3">
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'">
                    <div class="d-flex align-center">
                      <div style="width: 100%">
                        <!-- Rollover - fator que mult. o SALDO BONUS, resultando no valor a ser cumprido em apostas até que o saldo seja liberado -->
                        <v-text-field
                          v-model="rollover_x_value"
                          :rules="[rules.required, rules.negativeNo]"
                          :label="$t('rolloverMultiplier')"
                          hide-details="auto"
                          prepend-icon="mdi-dice-multiple"
                          prefix="x"
                          dense
                          outlined
                          type="number"
                        >
                          <template v-slot:append-outer>
                            <div class="tooltip">
                              <v-icon class="tooltipIcon">
                                mdi-information-outline
                              </v-icon>
                              <span class="tooltipText body-2">
                                {{ $t("multiRolloverTooltip") }}
                              </span>
                            </div>
                          </template>
                        </v-text-field>
                      </div>
                    </div>
                  </v-col>
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'">
                    <div class="d-flex align-center">
                      <div style="width: 100%">
                        <v-text-field
                          v-model="daysToExpire"
                          :label="$t('daysToExpire')"
                          :rules="[rules.required, rules.negativeNo]"
                          prepend-icon="mdi-calendar-clock"
                          hide-details="auto"
                          dense
                          outlined
                          type="number"
                          onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                        >
                          <template v-slot:append-outer>
                            <div class="tooltip">
                              <v-icon class="tooltipIcon"
                                >mdi-information-outline</v-icon
                              >
                              <span class="tooltipText body-2">{{
                                $t("daysToRollover")
                              }}</span>
                            </div>
                          </template>
                        </v-text-field>
                      </div>
                    </div>
                  </v-col>
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'">
                    <!-- Stake mínimo - mínimo valor por aposta para que seja considerado no cumprimento da promo -->
                    <v-text-field
                      v-model="stake_min_value"
                      :rules="[rules.required, rules.negativeNo]"
                      :label="$t('minBet')"
                      prepend-icon="mdi-cash-lock"
                      hide-details="auto"
                      dense
                      outlined
                      type="number"
                    >
                      <template v-slot:append-outer>
                        <div class="tooltip">
                          <v-icon class="tooltipIcon"
                            >mdi-information-outline</v-icon
                          >
                          <span class="tooltipText body-2"
                            >{{ $t("stakeMinValueTip1") }}
                            {{ $t("labelCurrency") }}
                            {{ $t("stakeMinValueTip2") }}</span
                          >
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'">
                    <!-- Multiplicador máximo -->
                    <v-text-field
                      v-model="multi_min_value"
                      :rules="[rules.negativeNo]"
                      :label="$t('minimumMultiplier')"
                      hide-details="auto"
                      prepend-icon="mdi-menu-up"
                      dense
                      outlined
                      type="number"
                    >
                      <template v-slot:append-outer>
                        <div class="tooltip">
                          <v-icon class="tooltipIcon">
                            mdi-information-outline
                          </v-icon>
                          <span class="tooltipText body-2">
                            {{ $t("multMinValueTip") }}
                          </span>
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'">
                    <!-- Multiplicador mínimo -->
                    <v-text-field
                      v-model="multi_max_value"
                      :rules="[rules.negativeNo]"
                      :label="$t('maximumMutiplier')"
                      hide-details="auto"
                      prepend-icon="mdi-menu-down"
                      dense
                      outlined
                      type="number"
                    >
                      <template v-slot:append-outer>
                        <div class="tooltip">
                          <v-icon class="tooltipIcon"
                            >mdi-information-outline</v-icon
                          >
                          <span class="tooltipText body-2">{{
                            $t("multMaxValueTip")
                          }}</span>
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
              </div>

              <div v-if="shouldHidePromotion">
                <v-subheader class="overline pt-4">
                  {{ $t("promotionVisibility") }}
                </v-subheader>
                <div class="pa-4 px-6 d-flex align-center">
                  <v-switch
                    v-model="hidePromotion"
                    :label="$t('hidePromotion')"
                  >
                  </v-switch>
                  <div class="tooltip">
                    <v-icon class="tooltipIcon">
                      mdi-information-outline
                    </v-icon>
                    <span class="tooltipText body-2">
                      {{
                        $t("hidePromotionTooltip", {
                          updateMessage: $t(
                            "hidePromotionTooltipUpdateMessage"
                          ),
                        })
                      }}
                    </span>
                  </div>
                </div>
              </div>

              <v-subheader class="overline pt-4">
                {{ $t("promotionImage") }}
              </v-subheader>
              <div class="pa-4 px-6">
                <v-card
                  style="max-width: 400px; max-height: 200px"
                  class="mb-2"
                  color="rgba(0, 0, 0, 0.2)"
                >
                  <div
                    class="d-flex justify-center align-center"
                    style="max-width: 400px; height: 200px;"
                  >
                    <div
                      v-if="(!image && !loadingPreview) || !passSizeTest"
                      class="text-center"
                      style="width: 100%;"
                    >
                      <div>
                        <v-icon size="100" color="rgba(255,255,255, 0.3)"
                          >mdi-image</v-icon
                        >
                      </div>
                      <div>
                        <span class="body-2">{{ $t("noImageLoaded") }}</span>
                      </div>
                    </div>
                    <div v-if="loadingPreview">
                      <v-skeleton-loader
                        class="mx-auto"
                        max-width="400"
                        type="image"
                      ></v-skeleton-loader>
                    </div>
                    <div
                      v-else-if="image != null && passSizeTest"
                      style="width: 100%;"
                    >
                      <v-img
                        :key="image"
                        v-if="image"
                        max-width="400"
                        max-height="200px"
                        contain
                        :src="image"
                      />
                    </div>
                  </div>
                </v-card>
                <div>
                  <p class="caption grey--text">
                    {{ $t("recommendedImagiSizePromoImage") }}
                  </p>
                </div>
                <!-- botoes -->
                <div style="max-width: 400px">
                  <div>
                    <div class="d-flex">
                      <div style="width: 100%">
                        <v-file-input
                          dense
                          outlined
                          :disabled="
                            !valid ||
                              imageConfirmed ||
                              (!image && !promotionCode && imageSelected)
                          "
                          @click.prevent="loadImage"
                          :label="$t('loadImage')"
                        />
                      </div>
                      <input
                        ref="image"
                        id="imgInput"
                        class="pb-6"
                        type="file"
                        @change="onFileChange"
                        required
                      />
                    </div>
                  </div>
                  <div
                    style="max-width: 400px"
                    class="d-flex justify-space-around"
                  >
                    <div
                      style="width: 100%"
                      :class="$vuetify.breakpoint.mobile ? '' : 'd-flex column'"
                    >
                      <div
                        :style="
                          $vuetify.breakpoint.mobile
                            ? 'width: 100%'
                            : 'width: 60%'
                        "
                      >
                        <v-btn
                          :loading="loading"
                          :disabled="
                            !image ||
                              fileNotAllowed ||
                              !passSizeTest ||
                              !!cachedImageKey ||
                              loading
                          "
                          :block="$vuetify.breakpoint.smAndDown"
                          class="info mb-4"
                          @click="addImage()"
                        >
                          {{ $t("toConfirm") }}
                        </v-btn>
                      </div>
                      <div
                        :hidden="!image || !passSizeTest || fileNotAllowed"
                        style="width: 100%"
                      >
                        <v-btn
                          color="#D50000"
                          :block="$vuetify.breakpoint.smAndDown"
                          @click="deleteImage(cachedImageKey, image)"
                        >
                          {{ $t("deleteImage") }}
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </div>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="mb-5"
          :block="$vuetify.breakpoint.smAndDown"
          :large="$vuetify.breakpoint.mobile"
          color="info"
          @click="addPromotion()"
          :loading="loading"
          :disabled="!valid || !imageConfirmed || loading"
        >
          {{ $t("toSave") }}
        </v-btn>
      </v-card-actions>
      <!-- deixar esse card aqui por enquanto para facilitar o debug list -->
      <!-- <v-card class="pb-4">
        <div v-for="(item, i) in imgList" :key="i">
          <div class="d-flex px-4 py-4">
            <div>
              <v-img max-width="180" :src="item.imageUrl"></v-img>
            </div>
            <div>
              <v-btn icon @click="deleteImage(item.imageKey)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </v-card> -->
    </v-card>
  </v-dialog>
</template>

<script>
import { validate } from "@/util/validate.js";
import AWS from "aws-sdk";
// import template from "./template.js";
import rules from "./generateFields/rules.js";
import functioning from "./generateFields/functioning.js";

var bucketName = "sga-assets";
var bucketRegion = "sa-east-1";
var domain = localStorage.getItem("operator");
var creds = new AWS.Credentials({
  accessKeyId: "accessKeyId",
  secretAccessKey: "secretAccessKey",
});

AWS.config.update({
  region: bucketRegion,
  credentials: creds,
});

var s3 = new AWS.S3({
  apiVersion: "2006-03-01",
  params: { Bucket: bucketName },
});

const allowedMimes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
const MAX_IMAGE_SIZE = 2000000; // max. 2MB
const MAX_IMAGE_WIDTH = 1800;
const MAX_IMAGE_HEIGHT = 800;
// let MAX_IMAGES; // max. images input
// let images_qtd = "";

export default {
  name: "backoffice-colab-dialog-create-new-promotion",
  data: () => ({
    //Validate Form
    valid: false,
    lazy: false,
    loading: false,
    // novos inputs
    promotionCode: "",
    quantityTokens: "",
    typePromotion: {},
    selectAffiliate: null,
    menuStart: "",
    dateStart: "",
    timeStart: "",
    menuFinal: "",
    dateFinal: "",
    timeFinal: "",
    daysToExpire: "",
    deposito_min_value: "",
    percentage_value: "",
    bonus_value: "",
    bonus_max_value: "",
    multi_min_value: "",
    multi_max_value: "",
    stake_min_value: "",
    rollover_x_value: "",
    transfer_max_value: "1",
    // novos inputs END
    isLoading: false,
    affiliates: [],
    search: null,
    term: "",
    // Selects Items
    items: [],
    // Errors
    hideDetailsStart: true,
    errorTimeStart: "",
    hideDetailsFinal: true,
    errorTimeFinal: "",
    // hideDetailsDate: true,
    //Rules
    rules: {
      noSpacesAreAllowed: validate.noSpacesAreAllowed,
      required: validate.required,
      negativeNo: validate.negativeNo,
      max20: validate.max20,
      maxQuantityTokens: validate.maxQuantityTokens,
      noSpecialCharactersAllowed: validate.noSpecialCharactersAllowed,
    },
    // add Image
    image: null,
    imageLoaded: false,
    imageSelected: false,
    passSizeTest: false,
    fileNotAllowed: false,
    cachedImageKey: "",
    loadingPreview: false,
    param: "",
    url: "",
    order: 0,
    file: null,
    max_img_promo: "",
    // list Image
    imgList: [],
    // Delete Image
    imgModel: "",
    imageConfirmed: false,
    // DEBUG DATE START
    // computedDateFormattedStart: "",
    // computedDateFormattedFinal: "",

    promotion_title: "",
    promotion_description: "",
    sigla: "",

    // Tooltips
    showMaxTransfer_Tooltip: false,
    showRollover_x_Tooltip: false,
    showDaysToExpire_Tooltip: false,
    hidePromotion: false,
  }),
  computed: {
    isPromotionToken() {
      return this.typePromotion.status == "token";
    },

    isPromotionTypeDeposit() {
      return (
        this.typePromotion.status == "deposito" ||
        this.typePromotion.status == "1ºdeposito"
      );
    },

    shouldHidePromotion() {
      return (
        this.typePromotion.status == "deposito" ||
        this.typePromotion.status == "1ºdeposito" ||
        this.typePromotion.status == "cadastro"
      );
    },

    // esconder campo Bonus_max_value
    isPromotionTypeRegisterOrAffiliate() {
      return (
        this.typePromotion.status == "cadastro" ||
        this.typePromotion.status == "afiliado"
      );
    },
    operator_name() {
      return this.$operator.operator_name;
    },
    computedDateFormattedStart() {
      return this.formatDate(this.dateStart);
    },
    computedDateFormattedFinal() {
      return this.formatDate(this.dateFinal);
    },
    dialog() {
      return this.$store.state.showDialog;
    },
    dateGetTimezoneOffset() {
      return new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
    },
    computedImageKey() {
      return this.imgList[0].imageKey;
    },
  },
  mounted() {
    // this.listImages("promotions");
    this.passSizeTest = false;
    this.items = [
      // cadastro; cadastro_por_afiliado, 1ºdeposito e depósito
      { text: this.$t("affiliate"), status: "afiliado" },
      { text: this.$t("register"), status: "cadastro" },
      { text: this.$t("deposit"), status: "deposito" },
      { text: this.$t("firstDeposit"), status: "1ºdeposito" },
      { text: "Token", status: "token" },
    ];
    this.typePromotion = { text: this.$t("affiliate"), status: "afiliado" };
    this.dateStart = this.dateGetTimezoneOffset;
    this.timeStart = "00:00:00";
    this.dateFinal = this.dateGetTimezoneOffset;
    this.timeFinal = "23:59:59";
  },
  watch: {
    dialog(val) {
      if (val) {
        const container = document.querySelector(".v-dialog--persistent");

        if (container) {
          this.$vuetify.goTo(".top", { container });
        }
      }
    },
    promotionCode(val) {
      this.promotionCode = val ? val.toUpperCase() : "";
    },
    timeStart(val) {
      if (val.length == 8) {
        this.timeValidated(val, "start");
      } else {
        this.errorTimeStart = "";
        this.hideDetailsStart = true;
      }
    },

    timeFinal(val) {
      if (val.length == 8) {
        this.timeValidated(val, "final");
      } else {
        this.errorTimeFinal = "";
        this.hideDetailsFinal = true;
      }
    },
    search(val) {
      // Caso o usuário selecionar um usuário da lista
      // não permitir realizar o get novamente.
      // O regex abaixo identifica os caracteres "(" e ")"
      // Contido na string e encerra dando return.
      if (/\(|\)/.test(val)) return;
      // aqui
      if (!val || val.length <= 0) {
        this.search_agent_items = [];
        this.sigla = "";
        this.term = "";
        return;
      }
      if (this.search_agent_isLoading) return;
      // Request

      if (val.length != 3 || val == this.sigla) {
        return;
      }

      this.sigla = val;

      if (val.length >= 3 && val != this.term) {
        this.term = val;
        this.getAffiliateList();
      }
      // aqui acaba
      // if (val == null || val.length <= 0) return;

      // if (this.isLoading) return;

      // // Request
      // if (val.length >= 3 && val != this.term) {
      //   this.term = val;
      //   this.getAffiliateList();
      // }
    },
    file() {
      if (!this.file) {
        this.imageConfirmed = false;
      }
      // Tipos não permitidos
      if (!allowedMimes.includes(this.file.type)) {
        this.fileNotAllowed = true;
        this.loading = false;
        this.image = null;
        document.getElementById("imgInput").value = "";
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("fileTypeNotAllowedImage"),
          color: "warning",
        });
      }
      if (this.file.type > MAX_IMAGE_SIZE) {
        this.fileNotAllowed = true;
        this.loading = false;
        this.image = null;
        // this.imageSelected = false;
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("imageTooLarge"),
          color: "warning",
        });
      }
    },
    rollover_x_value(val) {
      this.rollover_x_value = val ? parseInt(this.rollover_x_value) : "";
    },
    daysToExpire(val) {
      this.daysToExpire = val ? parseInt(this.daysToExpire) : "";
    },
  },
  methods: {
    loadImage() {
      this.$refs.image.click();
    },
    addPromotion() {
      this.loading = true;

      if (!this.$refs.form.validate()) {
        this.loading = false;
        return;
      }

      const body = {
        tipo: this.typePromotion.status, // cadastro, afiliado, deposito, 1ºdeposito.
        qtd_tokens: this.quantityTokens, // passa a quantidade de tokens se a promo for tipo token
        codigo: this.promotionCode, // obrigatorio
        dias_expiracao: this.daysToExpire, // obrigatorio
        data_inicio: `${this.dateStart} ${this.timeStart}`, // obrigatorio
        data_final: `${this.dateFinal} ${this.timeFinal}`, // obrigatorio
        id_afiliado:
          this.typePromotion.status == "afiliado"
            ? this.selectAffiliate.id
            : "", // opcional
        deposito_min: this.deposito_min_value, // Para promos de deposito. Minimo valor para que seja ativada a promo
        bonus: this.bonus_value, // Obrigatorio. Dependendo do tipo pode ser aplicado como percentual ou valor absoluto.
        bonus_max: this.bonus_max_value, // Valor maximo de bonus a ser concedido no caso de percentual
        multi_min: this.multi_min_value, // Multiplicador minimo para poder realizar apostas de bonus
        multi_max: this.multi_max_value, // Multiplicador maximo para poder realizar apostas de bonus
        stake_min: this.stake_min_value, // Obrigatorio. Minimo valor por aposta para que seja considerado no cumprimento da promo.
        rollover_x: this.rollover_x_value, // Obrigatorio. Fator que multiplica o SALDO BONUS resultado no valor a ser cumprido em apostas ate que o saldo seja liberado.
        transfer_max: this.transfer_max_value, // Caso exista limita a transferencia para saldo real
        titulo: this.promotion_title,
        descricao: this.promotion_description,
        hide: this.hidePromotion ? "1" : "0",
      };

      if (this.typePromotion.status == "afiliado") {
        body.affiliateName = this.selectAffiliate.name;
      }

      body.regras = rules(body, this.operator_name);
      body.funcionamento = functioning(body);

      delete body.affiliateName;

      if (body.data_inicio > body.data_final) {
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("dateStartGreaterThanEndDate"),
          color: "red",
        });
        this.loading = false;
        return;
      }

      this.$axios
        .post("/colab/promotions/addPromotion", this.$formdata(body))
        .then((response) => {
          this.$store.commit("setFeedbackSnack", {
            msg: response.data.messages,
            color: "success",
          });
          this.$emit("promotionAdded");
          this.closeDialog();
          this.loading = false;
        })
        .catch((error) => {
          if (
            error.response.data.dados &&
            error.response.data.dados.codePromotionUsed
          ) {
            this.deleteImage(this.cachedImageKey, this.image, false);
            this.promotionCode = "";
          }

          this.$store.commit("setFeedbackSnack", {
            msg: error.response.data.messages.error,
            color: "warning",
          });
          this.loading = false;
        });
    },
    // Get Lista de agentes
    async getAffiliateList() {
      this.isLoading = true;
      try {
        const response = await this.$request.post(
          "colab/affiliates/searchAffiliate",
          {
            term: this.term,
          }
        );

        if (response.length == 0) {
          this.affiliates = [];
          return;
        }

        this.affiliates = response.dados.map((item) => ({
          ui: `${item.nome} (${item.login} ${item.id})`,
          name: item.nome,
          icon: item.online,
          login: item.login,
          id: item.id,
        }));
      } finally {
        this.isLoading = false;
      }
    },
    reset() {
      this.typePromotion = { text: this.$t("affiliate"), status: "afiliado" };
      this.promotionCode = "";
      this.quantityTokens = "";
      (this.daysToExpire = ""), (this.dateStart = this.dateGetTimezoneOffset);
      this.timeStart = "00:00:00";
      this.dateFinal = this.dateGetTimezoneOffset;
      this.timeFinal = "23:59:59";
      this.selectAffiliate = null;
      this.deposito_min_value = "";
      (this.bonus_value = ""), (this.bonus_max_value = "");
      this.multi_min_value = "";
      this.multi_max_value = "";
      this.stake_min_value = "";
      this.rollover_x_value = "";
      this.transfer_max_value = "1";
      this.promotion_title = "";
      this.promotion_description = "";
      this.cachedImageKey = "";
      this.image = null;
      this.passSizeTest = false;
      this.imageLoaded = false;
      this.loadingPreview = false;
      this.hideDetailsStart = true;
      this.hideDetailsFinal = true;
      this.imageConfirmed = false;
      this.hidePromotion = false;
      if (document.getElementById("imgInput")) {
        document.getElementById("imgInput").value = "";
      }
      this.$refs.form.resetValidation();
    },
    // Valida se as horas são validas
    timeValidated(time, moment) {
      if (time > "23:59:59") {
        if (moment == "start") {
          this.errorTimeStart = this.$t("invalidTime");
          this.hideDetailsStart = true;
          return;
        } else {
          this.errorTimeFinal = this.$t("invalidTime");
          this.hideDetailsFinal = true;
        }
      }
      this.errorTime = "";
      this.hideDetails = false;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    closeDialog() {
      this.reset();
      this.$store.commit("showDialog", false);
    },
    openDialog() {
      this.$store.commit("showDialog", true);
    },

    // Input FILE
    onFileChange(element) {
      this.image = null;
      this.fileNotAllowed = false;
      this.passSizeTest = false;
      this.cachedImageKey = "";
      // this.loading = false
      // this.disabled = false;
      let files = element.target.files || element.dataTransfer.files;
      if (!files.length) {
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("chooseAnImageFirst"),
          color: "warning",
        });
        return;
      }
      this.loadingPreview = true;
      // STORE FILE
      this.file = files[0];

      const _this = this;
      // Generate pre-view image UI
      let reader = new FileReader();
      reader.onload = (element) => {
        // validacao width x height da imagem
        let image = new Image();
        image.src = element.target.result;
        image.onload = function() {
          var height = this.height;
          var width = this.width;
          // MAX_IMAGE_WIDTH
          // MAX_IMAGE_HEIGHT
          if (height > MAX_IMAGE_HEIGHT || width > MAX_IMAGE_WIDTH) {
            _this.$store.commit("setFeedbackSnack", {
              msg: _this.$t("warningMaxSize"),
              color: "warning",
            });
            document.getElementById("imgInput").value = "";
            this.image = null;

            return (_this.passSizeTest = false), (_this.imageSelected = false);
          } else {
            _this.passSizeTest = true;
            _this.imageSelected = true;
          }
          // return (_this.passSizeTest = true), (_this.imageSelected = true);
        };
        this.image = element.target.result;
      };
      this.loadingPreview = false;
      reader.readAsDataURL(this.file);
    },

    // add Image
    addImage() {
      this.loading = true;
      if (!this.file || this.file == {}) {
        _this.imageConfirmed = false;
      }
      // validacoes de tipo de arquivo e tamanho da imagem (MB) - Linha 755
      var ext;
      switch (this.file.type) {
        case "image/png":
          ext = ".png";
          break;
        case "image/jpeg":
        case "image/jpg":
          ext = ".jpg";
          break;
        default:
          ext = ".png";
          break;
      }

      // Verificação para promoções de token, promotionCode recebe domain + timeStamp como um id único
      let timeStamp = new Date().getTime();
      if (this.isPromotionToken) {
        this.promotionCode = domain.toUpperCase() + timeStamp;
      }

      var domainImageKey = `domains/${domain}/promotions/`;
      var newImageKey = domainImageKey + this.promotionCode + ext;
      var upload = new AWS.S3.ManagedUpload({
        params: {
          Bucket: bucketName,
          Key: newImageKey,
          Body: this.file,
          ACL: "public-read",
        },
      });

      const _this = this;
      var promise = upload.promise();

      promise.then(
        function() {
          _this.$store.commit("setFeedbackSnack", {
            title: "Sucesso!",
            msg: _this.$t("loadImageSuccess"),
            color: "success",
          });
          _this.imageLoaded = false;
          _this.listImages("promotions");
          _this.cachedImageKey = newImageKey;
          _this.loading = false;
          _this.imageConfirmed = true;
        },
        function(err) {
          _this.imageConfirmed = false;

          console.log(err);
        }
      );
    },
    // List Images
    listImages(param) {
      this.param = param;
      var carousel = {
        Prefix: `domains/${domain}/${param}/`,
      };
      const _this = this;
      var promise = s3.listObjects(carousel).promise();
      promise
        .then(function(data) {
          var href = "https://s3.sa-east-1.amazonaws.com/";
          var bucketUrl = href + bucketName + "/";
          var images = data.Contents.map(function(image) {
            var date = image.LastModified;
            var imageKey = image.Key;
            var imageUrl = bucketUrl + encodeURIComponent(imageKey);
            return { imageKey, imageUrl, date };
          });
          _this.imgList = images;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteImage(imageKey, fileImage) {
      this.imageConfirmed = false;

      if (imageKey) {
        // deleting Image from AWS s3
        const _this = this;
        s3.deleteObject({ Key: imageKey }, function(err) {
          if (err) {
            return alert(_this.$t("errorDeletingImage"), err.message);
          }
          _this.$store.commit("setFeedbackSnack", {
            msg: _this.$t("deletedImage"),
            color: "warning",
          });
          _this.listImages("promotions");
        });
        document.getElementById("imgInput").value = "";
        this.cachedImageKey = "";
        this.image = null;
        this.imageLoaded = false;
        this.imageSelected = false;
      }
      if (fileImage) {
        // Deleting before upload to AWS
        if (!this.image) return;
        // reseta o <input>
        document.getElementById("imgInput").value = "";
        this.imageLoaded = false;
        this.fileNotAllowed = false;
        this.imageSelected = false;
        // reseta o v-img
        this.image = null;
      }
    },
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.cursorPointer {
  cursor: pointer;
}
.v-tooltip__content {
  max-width: 320px;
}
.tooltipIcon {
  color: rgb(33, 150, 243);
}

.tooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.tooltip .tooltipText {
  visibility: hidden;
  width: 320px;
  margin: auto;
  max-width: 280px;
  background-color: rgb(87, 87, 87);
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding: 12px 16px;
  bottom: 36px;
  right: -10%;
  hyphens: auto;
  word-break: normal;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltipText {
  visibility: visible;
}
</style>
